"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCorePayoutStatusEnum = void 0;
var BillingCorePayoutStatusEnum;
(function (BillingCorePayoutStatusEnum) {
  /** Новый. Создан объект выплаты с базовой информацией */
  BillingCorePayoutStatusEnum["NEW"] = "NEW";
  /** В состоянии трансфера */
  BillingCorePayoutStatusEnum["TRANSFER"] = "TRANSFER";
  /** В состоянии перевода в банк получателя */
  BillingCorePayoutStatusEnum["PAYOUT"] = "PAYOUT";
  /** Отменён */
  BillingCorePayoutStatusEnum["CANCELED"] = "CANCELED";
  /** Успешно выплачено */
  BillingCorePayoutStatusEnum["SUCCESS"] = "SUCCESS";
  /** Ошибка инициализации */
  BillingCorePayoutStatusEnum["INIT_ERROR"] = "INIT_ERROR";
  /** Ошибка подготовки к выплате */
  BillingCorePayoutStatusEnum["PREPARE_ERROR"] = "PREPARE_ERROR";
  /** Ошибка на этапе обработки в модуле мерчант-провайдера */
  BillingCorePayoutStatusEnum["MERCHANT_ERROR"] = "MERCHANT_ERROR";
  /** Непредвиденная ошибка */
  BillingCorePayoutStatusEnum["ERROR"] = "ERROR";
})(BillingCorePayoutStatusEnum = exports.BillingCorePayoutStatusEnum || (exports.BillingCorePayoutStatusEnum = {}));
